import React from "react";

interface CorrectiveActionsProps {
  correctiveActions?: string;
}

export function CorrectiveActions({
  correctiveActions,
}: CorrectiveActionsProps) {
  let parsedActions: string[] | string;

  if (!correctiveActions) {
    return <div>-</div>;
  }

  try {
    // JSON parse
    parsedActions = JSON.parse(correctiveActions);
  } catch {
    // If its not a JSON, then just use the string
    parsedActions = correctiveActions;
  }

  return (
    <div>
      {Array.isArray(parsedActions) ? (
        parsedActions.map((note, index) => (
          <div key={index}>
            <span>{note}</span>
          </div>
        ))
      ) : (
        <div>
          <span>{parsedActions}</span>
        </div>
      )}
    </div>
  );
}
